export {
  Highlight,
  defaultHighlightFn,
  type HighlightProps,
} from './highlight';
